<template>
  <div class="q-mt-lg">
    <div
      class="row col-12 q-ml-md justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      <span> Produtos desta Necessidade </span>
      <q-btn
        @click="exportar"
        class=""
        style="border-radius: 8px; background-color: #304f78; color: white"
        no-caps
        icon="file_upload"
        label="Exportar"
      />
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      color="primary"
      :rows="rows"
      dense
      selection="multiple"
      class="tabela-tamanho-fixo"
      :columns="columns"
      :loading="disable"
      v-model:selected="selecionados"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      row-key="product_id"
      @request="handleRequest"
    >
      <template #body-cell-responsavel="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              dense
              v-model="props.row.matricula_responsavel"
              outlined
              label="Responsavel"
            >
            </q-input>
            <span v-else>{{ props.row.responsavel_nome }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-product_codigo="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              dense
              v-model="props.row.code"
              outlined
              label="Codigo
                "
            >
            </q-input>
            <span v-else>{{ props.row.product_codigo }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-ncm="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              style="width: 70px"
              dense
              v-model="props.row.ncm"
              outlined
              label="NCM"
            >
            </q-input>
            <span v-else>{{ props.row.produto_ncm }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-cost_center_code="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              style="width: 70px"
              dense
              v-model="props.row.cost"
              outlined
              label="Centro"
            >
            </q-input>
            <span v-else>{{ props.row.cost_center_code }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-purchase_order_price="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.purchase_order_price == null"
              dense
              v-model="props.row.price"
              outlined
              label="Preço"
            >
            </q-input>

            <span v-else>{{ props.row.purchase_order_price }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-delete="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <q-btn
            @click="deletar(props.row.uuid_item_fora_catalogo)"
            icon="sym_o_delete"
            round
            flat
            :disable="props.row.purchase_order_id != null"
            color="negative"
          />
        </q-td>
      </template>
      <template #body-cell-pedidoCompra="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div style="font-size: 15px; font-weight: bolder" class="row">
            <a
              v-if="props.row.purchase_order_id != null"
              class="target"
              rel="noopener noreferrer"
              @click="rota('compras-editar', props.row.purchase_order_id)"
              >{{ props.row.purchase_order_id }}</a
            >
            <span v-else>NÃO</span>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "tempo",
    label: "Inserido em:",
    field: (row) =>
      row.created_at
        ? row.created_at.split(" ")[0].split("-").reverse().join("/") +
          " " +
          row.created_at.split(" ")[1]
        : "Sem data",
    align: "left",

    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "cost_center_code",
    label: "Unid. Controle",
    field: " cost_center_code",
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "responsavel",
    label: "Responsável",
    field: "responsavel",
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "produto",
    label: "Produto",
    field: (row) => row.produto_nome,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },

  {
    name: "product_codigo",
    label: "Codigo",
    field: (row) => row.product_codigo,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },

  {
    name: "medida",
    label: "Unid. Medida SC",
    field: (row) => row.unidade_medida_necessidade,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "ncm",
    label: "NCM",
    field: (row) => row.produto_ncm,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "quantidadeNecessaria",
    label: "Qtd. de Compra",
    field: (row) => row.quantidade_necessaria,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "purchase_order_price",
    label: "R$ Unitário",
    field: (row) => row.purchase_order_price,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "cost_center_code",
    label: "Total",
    field: (row) => row.purchase_order_price * row.quantidade_necessaria,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "replacementAmount",
    label: "Reposição",
    field: (row) => row.replacement_amount,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },

  {
    name: "maxAmount",
    label: "Qtd. Máx",
    field: (row) => row.max_amount,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "amount",
    label: "Qtd. em Estoque",
    field: (row) => row.amount,
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },
  {
    name: "pedidoCompra",
    label: "Ped. Compra",
    field: "pedidoCompra",
    align: "left",
    style: (row) => (row.purchase_order_id ? "background-color: #C1DEC1;" : ""),
  },

  {
    name: "delete",
    label: "Remover",
    field: "delete",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute, useRouter } from "vue-router";

export default {
  props: ["info", "get"],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const selecionados = ref([]);
    const id = route.params.id;

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 25) => {
      try {
        const response = await store.dispatch(
          "compras/getProdutosNecessidade",
          {
            vendor_id: store.state.org.unidadeData.id,
            page,
            per_page: rowsPerPage,
            uuid: id,
          }
        );

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const rota = async (rota, param = "") => {
      if (param != "") {
        router.push({
          name: rota,
          params: { id: param },
        });
      } else {
        router.push({
          name: rota,
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/exportarProdutosNecessidade", {
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletar = async (uuid) => {
      try {
        await store.dispatch("compras/deletarProdutosNecessidade", {
          uuid: id,
          produtos: [{ produto_fora_catalogo_uuid: uuid }],
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
        emit("atualizar");
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarRequisicao = async () => {
      let produtos = [];
      props.info.itens.products.forEach((e) => {
        produtos.push({
          amount: e.produto.amount,
          id: e.produto.id,
          product_id: e.produto.id,
          quantidade_necessaria: e.produto.quantidadeNecessaria,
        });
      });

      try {
        await store.dispatch("compras/criarRequisicao", {
          cost_center_id: props.info.costCenter.id,
          numero: props.info.numero,
          plantiff_id: props.info.solicitante.usuario.id,
          vendor_id: store.state.org.unidadeData.id,
          products: produtos,
        });

        $q.notify({
          message: "Requisição criada com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editar = async (dados) => {
      try {
        if (dados.matricula_responsavel) {
          await store.dispatch("compras/editarProdutosNecessidadeNome", {
            need_id: id,
            matricula_responsavel: dados.matricula_responsavel,
            uuid: dados.uuid_item,
          });
        }
        if (dados.code) {
          await store.dispatch("compras/editarProdutosNecessidadeCode", {
            code: dados.code,
            need_id: id,
            product_uuid: dados.uuid_item,
          });
        }
        if (dados.ncm) {
          await store.dispatch("compras/editarProdutosNecessidadeNcm", {
            ncm: dados.ncm,
            need_id: id,
            uuid: dados.uuid_item,
          });
        }

        if (dados.cost) {
          await store.dispatch("compras/editarProdutosNecessidadeCost", {
            cost_center_code: dados.cost,
            need_id: id,
            uuid: dados.uuid_item,
          });
        }

        $q.notify({
          message: "Editado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    const selecionarTudo = async () => {
      selecionados.value = ["1"];
      selecionados.value.pop();
      rows.value.forEach((e) => {
        if (e.purchase_order_id == null) {
          selecionados.value.push(e);
        }
      });
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    watch(
      () => props.get,
      () => {
        getDados();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selecionados,
      rota,
      exportar,
      deletar,
      selecionarTudo,
      criarRequisicao,
      editar,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}

.no-wrap {
  flex-wrap: nowrap !important;
}

.target {
  cursor: pointer;
  color: #4a93f8;
}

.my-special-class {
  background-color: #c1dec1 !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
